import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";
import "./BuildingGrid.css";
import "./FrameCrossSection.scss";

//Components
import DataTable from "react-data-table-component";
import Layout from "../../../../Layout/Layout";
import Constants from "../../../../common/SupplierConstants";
import { SearchField } from "../../../../Components/formElements/SearchField";
// import { formatDate, } from "../../../common/Validatieons";
import CustomerConstants from "../../../../common/CustomerConstants";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
// import QuotationModel from "./QuotationModel";
// import CommonFilterCustomerV2 from "../../Customer_V2/Common/CommonFilterCustomerV2";
import { formatDate } from "../../../../common/Validations";
import EstimateModel from "./EstimateModel";
import EstimateUploadModal from "./EstimateUploadModal";
import ItemServiceV2 from "../../../../services/customer_v2_appCommonService";
// import QuotationUploadDataViewModal from "../Quotation_V1/QuotationUploadDataViewModal";
import EstimateUploadDataViewModal from "./EstimateUploadDataViewModal";
// import { InputField } from "../../../../Components/formElements/InputField";

const EstimateList = () => {
  // const dispatch = useDispatch();
  const navigate = useNavigate();

  localStorage.setItem("menu", "");
  localStorage.setItem("submenu", "");

  // const [getNewPerPage, setNwPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  const [filterShow, setFilterShow] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [parsedData, setParsedData] = useState([]);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [showDataModal, setShowDataModal] = useState(false);

  const handleSave = async () => {
    const allPayloads = [];

    parsedData.forEach((item) => {
      const credit = parseFloat(item.creditAmount || 0);
      const debit = parseFloat(item.debitAmount || 0);
      const type = item.type;

      let originalPayload, reversePayload;

      if (type === "DEBIT") {
        // Company pays (Salary, Expense, etc.)
        // Company credited, Customer debited
        originalPayload = {
          data: {
            companyCode: item.companyCode,
            companyCodeDesc: item?.companyCodeDesc,
            customerCodeDesc: item?.customerCodeDesc,
            transaction: "Payment",
            transactionType: "BK",
            customerCode: "",
            bankName: item.companyBankName,
            customerBank: item.customerBank,
            companyBank: item.companyBank,
            transactionMode: item.transactionMode,
            bankTransactionDate: item.bankTransactionDate,
            partyCode: item.partyCode,
            remarks: item.remarks,
            type: "CREDIT", // ✅ Company credited
            items: [
              {
                slNo: "1",
                creditAmount: debit, // ✅ company credited
                debitAmount: 0,
                transaction: "Payment",
              },
            ],
            documentNumber: item.documentNumber,
            invoiceNr: item.invoiceNr,
            invoiceStatusHeader: item.invoiceStatusHeader,
            createdBy: item.createdBy,
            createdByName: item.createdByName,
            createdAt: item.createdAt,
            updatedAt: item.updatedAt,
          },
        };

        reversePayload = {
          data: {
            companyCode: "",
            companyCodeDesc: item?.companyCodeDesc,
            customerCodeDesc: item?.customerCodeDesc,
            transaction: "Receipt",
            transactionType: "BK",
            customerCode: item.customerCode,
            customerBankName: item.customerBankName,
            customerBank: item.customerBank,
            companyBank: item.companyBank,
            transactionMode: item.transactionMode,
            bankTransactionDate: item.bankTransactionDate,
            partyCode: item.partyCode,
            remarks: item.remarks,
            type: "DEBIT", // ✅ Customer debited
            items: [
              {
                slNo: "1",
                creditAmount: 0,
                debitAmount: debit, // ✅ driver debited
                transaction: "Receipt",
              },
            ],
            documentNumber: item.documentNumber,
            invoiceNr: item.documentNumber,
            invoiceStatusHeader: item.invoiceStatusHeader,
            createdBy: item.createdBy,
            createdByName: item.createdByName,
            createdAt: item.createdAt,
            updatedAt: item.updatedAt,
          },
        };
      } else if (type === "CREDIT") {
        // Customer pays (Income, Receipt, etc.)
        // Company debited, Customer credited
        originalPayload = {
          data: {
            companyCode: item.companyCode,
            companyCodeDesc: item?.companyCodeDesc,
            customerCodeDesc: item?.customerCodeDesc,
            transaction: "Receipt",
            transactionType: "BK",
            customerCode: "",
            bankName: item.companyBankName,
            customerBank: item.customerBank,
            companyBank: item.companyBank,
            transactionMode: item.transactionMode,
            bankTransactionDate: item.bankTransactionDate,
            partyCode: item.partyCode,
            remarks: item.remarks,
            type: "DEBIT", // ✅ Company debited
            items: [
              {
                slNo: "1",
                creditAmount: 0,
                debitAmount: credit, // ✅ company debited
                transaction: "Receipt",
              },
            ],
            documentNumber: item.documentNumber,
            invoiceNr: item.invoiceNr,
            invoiceStatusHeader: item.invoiceStatusHeader,
            createdBy: item.createdBy,
            createdByName: item.createdByName,
            createdAt: item.createdAt,
            updatedAt: item.updatedAt,
          },
        };

        reversePayload = {
          data: {
            companyCode: "",
            companyCodeDesc: item?.companyCodeDesc,
            customerCodeDesc: item?.customerCodeDesc,
            transaction: "Payment",
            transactionType: "BK",
            customerCode: item.customerCode,
            customerBankName: item.customerBankName,
            customerBank: item.customerBank,
            companyBank: item.companyBank,
            transactionMode: item.transactionMode,
            bankTransactionDate: item.bankTransactionDate,
            partyCode: item.partyCode,
            remarks: item.remarks,
            type: "CREDIT", // ✅ Customer credited
            items: [
              {
                slNo: "1",
                creditAmount: credit, // ✅ customer credited
                debitAmount: 0,
                transaction: "Payment",
              },
            ],
            documentNumber: item.documentNumber,
            invoiceNr: item.documentNumber,
            invoiceStatusHeader: item.invoiceStatusHeader,
            createdBy: item.createdBy,
            createdByName: item.createdByName,
            createdAt: item.createdAt,
            updatedAt: item.updatedAt,
          },
        };
      }

      if (originalPayload) allPayloads.push(originalPayload);
      if (reversePayload) allPayloads.push(reversePayload);
    });
    // setDisabled(true);
    // setLoading(true);
    // const failedEntries = [];

    // try {
    //   for (const payload of allPayloads) {
    //     const response = await ItemServiceV2.addInvoice(payload);
    //     if (!response || response.status !== 200) {
    //       failedEntries.push(
    //         payload.data.companyCodeDesc || payload.data.companyCode
    //       );
    //     }
    //   }

    //   if (failedEntries.length === 0) {
    //     toast.success("All bank statements uploaded successfully", {
    //       duration: 3000,
    //       position: "top-right",
    //     });
    //     dispatch(
    //       getBankStatement({
    //         queryName: "Customer_BankAndExpenses_List",
    //         transactionType: "BK",
    //       })
    //     );
    //     setShowDataModal(false);
    //   } else {
    //     toast.error(`Failed to upload for: ${failedEntries.join(", ")}`, {
    //       duration: 5000,
    //       position: "top-right",
    //     });
    //   }
    // } catch (err) {
    //   toast.error("Something went wrong during upload", {
    //     duration: 5000,
    //     position: "top-right",
    //   });
    // } finally {
    //   // setDisabled(false);
    //   // setLoading(false);
    // }
  };
  const handleUploadComplete = async ({ jsonData, file }) => {
    const enrichedData = await Promise.all(
      jsonData.map(async (row) => {
        // Fetch customer name
        let customerName = "";
        try {
          const obj1 = {
            queryName: "getCustomerName",
            documentNumber: row.customerCode,
          };
          const custRes = await ItemServiceV2.generateCustomerQuery(obj1);
          if (custRes?.status === 200 && custRes?.data?.length > 0) {
            customerName = custRes.data[0].organisationName;
          }
        } catch (err) {
          console.error("Error fetching customer name", err);
        }

        // Fetch company name
        let companyName = "";
        try {
          const obj2 = {
            queryName: "getCompanyName",
            companyCode: row.companyCode,
          };
          const compRes = await ItemServiceV2.generateCustomerQuery(obj2);
          if (compRes?.status === 200 && compRes?.data?.length > 0) {
            companyName = compRes.data[0].companyCodeDesc;
          }
        } catch (err) {
          console.error("Error fetching company name", err);
        }

        return {
          ...row,
          customerCodeDesc: customerName,
          companyCodeDesc: companyName,
        };
      })
    );

    setParsedData(enrichedData);
    setUploadedFile(file);
    setShowDataModal(true);
  };

  // let cashData = useSelector((state) => state?.customer?.cashRequest); // User Details from Store

  // let cashDataTable = useSelector(
  //   (state) => state?.customer?.cashRequest.pagination
  // ); // User Details from Store

  const [isCardVisible1, setCardVisible1] = useState(true);
  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };

  // const [data, setData] = useState();
  // const filteredData = data?.filter(
  //   (item) =>
  //     item.cashRequestStatus === "Partial Amount" ||
  //     item.cashRequestStatus === "Cash in Transit"
  // );

  const estimationColumns = [
    {
      name: "Estimate Number",
      selector: (row) => row?.estimateNumber,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPage(row?.estimateNumber)}
        >
          {row?.estimateNumber || "-"}
        </button>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Status",
      cell: (row) => <TableStatusField status={`${row?.estimateStatus}`} />,
      width: "180px",
    },
    {
      name: "Customer",
      selector: (row) => row.customerName,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.customerName}</p>
          <p className="m-0 p-0">{row.customerCode}</p>
        </div>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Sales Officer",
      selector: (row) => row.salesOfficerName,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.salesOfficerName}</p>
          <p className="m-0 p-0">{row.salesOfficerCode}</p>
        </div>
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "Estimated Amount",
      selector: (row) => row.estimatedAmount,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{`${row.currency} ${row.estimatedAmount}`}</p>
        </div>
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "Created Date",
      selector: (row) => row.estimateDate,
      cell: (row) => <span>{formatDate(row.estimateDate)}</span>,
      sortable: true,
      width: "130px",
    },
    {
      name: "Valid Until",
      selector: (row) => row.validUntil,
      cell: (row) => <span>{formatDate(row.validUntil)}</span>,
      sortable: true,
      width: "130px",
    },
    {
      name: "Created By",
      selector: (row) => row.createdByUser,
      cell: (row) => <span>{row.createdByUser}</span>,
      sortable: true,
      width: "130px",
    },
  ];

  // const loadInitialSuuplierData = async () => {
  //   // setData(cashData?.data);
  // };

  const handlePageChange = (page) => {
    // let obj = {
    //   queryName: "",
    //   module: "CUSTOMER",
    //   page: page,
    //   per_page: getNewPerPage,
    // };
    // dispatch(getCashRequest(obj));
    // setData(cashData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    // let obj = {
    //   queryName: "",
    //   module: "CUSTOMER",
    //   page: page,
    //   per_page: newPerPage,
    // };
    // setNewPerPage(newPerPage);
    // dispatch(getCashRequest(obj));
    // setData(cashData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    //   let obj = {
    //     queryName: "",
    //     module: "CUSTOMER",
    //     page: 1,
    //     per_page: 10,
    //     searchTerm: getCommonSearchTxt,
    //   };
    //   dispatch(getCashRequest(obj));
  };

  // useEffect(() => {
  //   loadInitialSuuplierData(); // fetch page 1 of users
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [cashData]);

  //on page load
  useEffect(() => {
    // let obj = {
    //   queryName: "getCashRequestList",
    //   module: "CUSTOMER",
    //   page: 1,
    //   per_page: 10,
    // };
    // dispatch(getCashRequest(obj));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //navigate
  const detailedPage = (customerID) => {
    // dispatch(cashRequestNr(customerID));
    navigate(CustomerConstants.CUSTOMER_V2_EXPENSES_UPDATE);
  };

  const [modalCashRequestShowStatus, setModalCashRequestShowStatus] =
    useState(false);

  /* show Cash request Modal Function */
  // eslint-disable-next-line
  const showCashRequestModal = () => {
    setModalCashRequestShowStatus(true);
  };
  const hideModalStatus = () => {
    setModalCashRequestShowStatus(false); //hide cash request modal
  };

  // const handleAdvanceSearchFuncApi = (filter) => {};
  const estimationData = [
    {
      estimateNumber: "E-20250901-001",
      estimateStatus: "Submitted",
      customerName: "Global Solutions Inc.",
      customerCode: "CUST001",
      salesOfficerName: "Jane Doe",
      salesOfficerCode: "SO123",
      estimatedAmount: 14800.0,
      estimateDate: "2025-09-01",
      validUntil: "2025-09-15",
      currency: "USD",
      createdByUser: "user1",
    },
    {
      estimateNumber: "E-20250902-002",
      estimateStatus: "Pending",
      customerName: "Tech Innovators LLC",
      customerCode: "CUST002",
      salesOfficerName: "John Smith",
      salesOfficerCode: "SO456",
      estimatedAmount: 950.0,
      estimateDate: "2025-09-02",
      validUntil: "2025-09-10",
      currency: "EUR",
      createdByUser: "user2",
    },
    {
      estimateNumber: "E-20250828-003",
      estimateStatus: "Pending",
      customerName: "Future Enterprises",
      customerCode: "CUST003",
      salesOfficerName: "Emily White",
      salesOfficerCode: "SO789",
      estimatedAmount: 26200.5,
      estimateDate: "2025-08-28",
      validUntil: "2025-09-15",
      currency: "USD",
      createdByUser: "user1",
    },
    {
      estimateNumber: "E-20250903-004",
      estimateStatus: "Submitted",
      customerName: "Innovative Systems Co.",
      customerCode: "CUST004",
      salesOfficerName: "Michael Brown",
      salesOfficerCode: "SO101",
      estimatedAmount: 4350.0,
      estimateDate: "2025-09-03",
      validUntil: "2025-09-20",
      currency: "CAD",
      createdByUser: "user3",
    },
  ];
  const BankUploadColumns = [
    {
      name: "Company",
      id: "companyCode",
      sselector: (row) => row.companyCode,
      cell: (row) => (
        <div>
          <p class="">{row.companyCodeDesc}</p>
          <p class="">{row.companyCode}</p>
        </div>
      ),
      sortable: true,
      width: "240px",
    },
    {
      name: "Company Bank",
      selector: (row) => row.companyBankName,
      sortable: true,
      width: "140px",
    },

    {
      name: "Customer",
      cell: (row) => (
        <div className="d-flex flex-column">
          <p className="m-0 fw-bold"> {row.customerCode} </p>
          <p className="m-0"> {row.customerCodeDesc} </p>
        </div>
      ),
      width: "160px",
    },
    {
      name: "Customer Bank",
      selector: (row) => row.customerBankName,
      sortable: true,
      width: "140px",
    },

    {
      name: "Transaction Mode",
      selector: (row) => row.transactionMode,
      sortable: true,
      width: "140px",
    },
    {
      name: "Transaction Date",
      selector: (row) => row.bankTransactionDate,
      sortable: true,
      width: "140px",
    },
    {
      name: "Transaction Type",
      selector: (row) => row.type,
      sortable: true,
      width: "180px",
      cell: (row) => {
        const parseAmount = (val) =>
          parseFloat((val || "0").toString().replace(/,/g, ""));

        const credit = parseAmount(row.creditAmount);
        const debit = parseAmount(row.debitAmount);

        let displayType = "Invalid";
        // let badgeClass = "bg-table-status bg-table-warning-status";

        if (credit > 0 && debit === 0) {
          displayType = "Credit";
          // badgeClass = "bg-table-status bg-table-success-status";
        } else if (debit > 0 && credit === 0) {
          displayType = "Debit";
          // badgeClass = "bg-table-status bg-table-danger-status";
        }

        return <span>{displayType}</span>;
      },
    },

    {
      name: "Party",
      selector: (row) => {
        const map = {
          V: { label: "Vendor" },
          S: { label: "Supplier" },
          C: { label: "Customer" },
        };

        const party = map[row.partyCode];

        return <span>{party?.label || row.partyCode}</span>;
      },
      sortable: true,
      width: "140px",
    },

    {
      name: "Remarks",
      selector: (row) => row.remarks,
      sortable: true,
      width: "180px",
    },
    {
      name: "Debit",
      selector: (row) => row.debitAmount,
      sortable: true,
      width: "150px",
      // right: true,
    },
    {
      name: "Credit",
      selector: (row) => row.creditAmount,
      sortable: true,
      width: "150px",
      // right: true,
    },
  ];
  const navigateEstimation = () => {
    navigate(CustomerConstants.CUSTOMER_V4_CUSTOMER_ESTIMATE_E1);
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle">Estimate List</h2>
                <p className="subText">Estimate List</p>
              </Col>
              <Col
                xs={12}
                md={3}
                lg={3}
                className="d-flex justify-content-end mt-3"
              >
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
              <Col xs={12} md={1} lg={1}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i class="bi bi-filter"></i>
                </span>
              </Col>
            </Row>
            <hr />
            {/* {filterShow && (
              <CommonFilterCustomerV2
                getfiltereddata={[]} //pass datacolumn
                cancelAction={() => setFilterShow(!filterShow)}
                onSubmit={(filters) => {
                  handleAdvanceSearchFuncApi(filters);
                  // You can now use the filters here
                }}
              />
            )} */}
            {/* user list */}
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">EL</span>
                    </Col>
                    <Col xs={6} md={6} lg={6}>
                      <span className="headerTitle"> Estimate List</span>
                    </Col>
                    <Col xs={4} md={2} lg={2} className="">
                      <button
                        className="btnTable"
                        // onClick={() => showCashRequestModal()}
                        onClick={() => navigateEstimation()}
                      >
                        Create
                      </button>
                    </Col>
                    <Col xs={4} md={2} lg={2} className="">
                      <button
                        className="btnTable"
                        // onClick={() => showCashRequestModal()}
                        onClick={() => setShowUploadModal(true)}
                      >
                        Upload
                      </button>
                    </Col>
                    <Col xs={2} md={1} lg={1} className="">
                      <div className="filter">
                        <span
                          className="icon hide headerIcon"
                          data-bs-toggle="dropdown"
                          aria-expanded="true"
                        >
                          <i className="bi bi-three-dots"></i>
                        </span>
                        <ul
                          className="dropdown-menu dropdown-menu-end dropdown-menu-arrow hide menuList"
                          data-popper-placement="bottom-end"
                        >
                          <li className="dropdown-header text-start">
                            <h6>Menu</h6>
                          </li>
                          <li>
                            {/* <span
                                        className="dropdown-item headerIcon"
                                        onClick={handleDownloadExcel}
                                      >
                                        <i className="bi bi-download mr-2"></i>
                                        Download Excel
                                      </span> */}
                            <span
                            //                             onClick={
                            //                               !isDownloading
                            //                                 ? handleDownloadExcel
                            //                                 : undefined
                            //                             }
                            //                             className={`dropdown-item headerIcon flex items-center gap-2 px-3 py-2 rounded-md transition
                            // ${
                            //   isDownloading
                            //     ? "opacity-50 cursor-not-allowed pointer-events-none"
                            //     : "hover:bg-gray-100 cursor-pointer"
                            // }`}
                            >
                              <i className="bi bi-download"></i>
                              {/* {isDownloading
                                        ? "Downloading..."
                                        : "Download Excel"} */}
                            </span>
                            {/* <span
                                        className="dropdown-item headerIcon"
                                        onClick={() =>
                                          exportDataTableToExcel(
                                            tableData, // 🔹 your table data
                                            getledgersColumn, // 🔹 your column config
                                            "Stock_Summary.xlsx" // 🔹 export file name
                                          )
                                        }
                                      >
                                        <i className="bi bi-download mr-2"></i>
                                        Download Excel
                                      </span> */}
                          </li>
                        </ul>
                      </div>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={estimationColumns}
                          data={estimationData} // Assuming your quotation data is in a variable named `quotationData`
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* home diagram */}
            {/* <FrameCrossSection /> */}
          </div>
        </Col>
      </Row>

      {/* <BuildingGrid6 /> */}
      <EstimateModel
        show={modalCashRequestShowStatus}
        onHide={() => hideModalStatus()}
      />
      <EstimateUploadDataViewModal
        show={showDataModal}
        onHide={() => setShowDataModal(false)}
        data={parsedData}
        columns={BankUploadColumns}
        title="Uploaded Quotation"
        file={uploadedFile}
        onClick={handleSave}
        // disabled={disabled}
        // loading={loading}
      />
      <EstimateUploadModal
        show={showUploadModal}
        onHide={() => setShowUploadModal(false)}
        onUploadComplete={handleUploadComplete}
      />
    </main>
  );
};

// const FrameCrossSection = () => {
//   return (

//     <div className="frame-container">
//       <svg
//         viewBox="0 0 1000 600"
//         xmlns="http://www.w3.org/2000/svg"
//         className="frame-svg"
//       >
//         {/* input field  top left */}
//         <foreignObject x="250" y="15" width="100" height="40">
//           <input
//             type="text"
//             value={"1233"}
//             // placeholder="Enter value"
//             style={{
//               width: "100%",
//               height: "100%",
//               border: "1px solid black",
//               borderRadius: "4px",
//               padding: "10px",
//             }}
//             disabled
//           />
//           {/*  */}
//         </foreignObject>
//         <foreignObject x="250" y="100" width="100" height="40">
//           <input
//             type="text"
//             value={"1233"}
//             // placeholder="Enter value"
//             style={{
//               width: "100%",
//               height: "100%",
//               border: "1px solid black",
//               borderRadius: "4px",
//               padding: "10px",
//             }}
//             disabled
//           />
//         </foreignObject>

//         {/* input field  top right */}
//         <foreignObject x="650" y="15" width="100" height="40">
//           <input
//             type="text"
//             value={"1233"}
//             // placeholder="Enter value"
//             style={{
//               width: "100%",
//               height: "100%",
//               border: "1px solid black",
//               borderRadius: "4px",
//               padding: "10px",
//             }}
//             disabled
//           />
//           {/*  */}
//         </foreignObject>
//         <foreignObject x="650" y="100" width="100" height="40">
//           <input
//             type="text"
//             value={"1233"}
//             // placeholder="Enter value"
//             style={{
//               width: "100%",
//               height: "100%",
//               border: "1px solid black",
//               borderRadius: "4px",
//               padding: "10px",
//             }}
//             disabled
//           />
//         </foreignObject>

//         {/* Base rectangle (ground line) */}
//         <line x1="100" y1="500" x2="900" y2="500" className="base-line" />
//         {/* base line 2 */}
//         <line x1="100" y1="10" x2="900" y2="10" className="base-line" />

//         {/* Columns */}
//         <line x1="150" y1="0" x2="150" y2="500" className="column" />
//         <line x1="850" y1="0" x2="850" y2="500" className="column" />

//         {/*middle Columns  */}
//         <line x1="500" y1="0" x2="500" y2="500" className="column" />

//         {/* right side arrow */}
//         <line
//           x1="820"
//           y1="180"
//           x2="820"
//           y2="490"
//           className="arrow"
//           markerEnd="url(#arrow)" /* markerStart="url(#arrow)" */
//         />
//         <line
//           x1="820"
//           y1="200"
//           x2="820"
//           y2="180"
//           className="arrow"
//           markerStart="url(#arrow)" /* markerStart="url(#arrow)" */
//         />
//         {/* left side arrow */}
//         <line
//           x1="130"
//           y1="180"
//           x2="130"
//           y2="490"
//           className="arrow"
//           markerEnd="url(#arrow)" /* markerStart="url(#arrow)" */
//         />
//         <line
//           x1="130"
//           y1="200"
//           x2="130"
//           y2="180"
//           className="arrow"
//           markerStart="url(#arrow)" /* markerStart="url(#arrow)" */
//         />

//         {/* Roof slopes */}
//         <line x1="150" y1="200" x2="500" y2="100" className="roof" />
//         <line x1="850" y1="200" x2="500" y2="100" className="roof" />

//         {/* Labels */}
//         <text x="120" y="350" className="label" transform="rotate(-90 120,350)">
//           Eave Height (E.H)
//         </text>
//         <text x="870" y="350" className="label" transform="rotate(-90 870,350)">
//           Clear Height (E.C)
//         </text>
//         <text x="400" y="530" className="label">
//           Width (O/O of Steel Line)
//         </text>
//         <text x="480" y="80" className="label ridge">
//           Ridge
//         </text>

//         {/* Arrows */}
//         <line
//           x1="150"
//           y1="500"
//           x2="850"
//           y2="500"
//           className="arrow"
//           markerEnd="url(#arrow)" /* markerStart="url(#arrow)" */
//         />

//         {/* arrow start*/}
//         <line
//           x1="800"
//           y1="500"
//           x2="150"
//           y2="500"
//           className="arrow"
//           markerEnd="url(#arrow)"
//         />

//         {/* Arrow at top */}
//         <line
//           x1="140"
//           y1="10"
//           x2="840"
//           y2="10"
//           className="arrow"
//           markerEnd="url(#arrow)" /* markerStart="url(#arrow)" */
//         />
//         <line
//           x1="510"
//           y1="10"
//           x2="220"
//           y2="10"
//           className="arrow"
//           markerStart="url(#arrow)" /* markerStart="url(#arrow)" */
//         />
//         <line
//           x1="140"
//           y1="10"
//           x2="490"
//           y2="10"
//           className="arrow"
//           markerEnd="url(#arrow)" /* markerStart="url(#arrow)" */
//         />
//         <line
//           x1="160"
//           y1="10"
//           x2="120"
//           y2="10"
//           className="arrow"
//           markerStart="url(#arrow)" /* markerStart="url(#arrow)" */
//         />

//         {/* Arrow markers */}
//         <defs>
//           <marker
//             id="arrow"
//             markerWidth="10"
//             markerHeight="10"
//             refX="5"
//             refY="5"
//             orient="auto"
//           >
//             <path d="M0,0 L10,5 L0,10 Z" className="arrow-head" />
//           </marker>
//         </defs>
//       </svg>
//       <p className="caption">MAIN FRAME CROSS SECTION AT FRAME LINE-1</p>
//     </div>
//   );
// };

// const BuildingGrid6 = () => {
//   const [colCount, setColCount] = useState(0); // initially 0
//   const [rowCount, setRowCount] = useState(0); // initially 0

//   // Generate repeating column labels A..Z, A..Z...
//   const generateColumns = (count) => {
//     const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
//     return Array.from({ length: count }, (_, i) => alphabet[i % 26]);
//   };

//   const columns = generateColumns(colCount);
//   const rows = Array.from({ length: rowCount }, (_, i) => rowCount - i); // descending

//   const measures = Array(Math.max(columns.length - 1, 0)).fill("5000"); // top/bottom measures
//   const sideMeasures = Array(Math.max(rows.length + 2, 0)).fill("5000"); // left/right measures

//   return (
//     <>
//       <span>Grid 3</span>

//       {/* Input Fields */}
//       <div style={{ marginBottom: "1rem" }}>
//         <label>
//           Columns:{" "}
//           <input
//             type="number"
//             value={colCount}
//             onChange={(e) => setColCount(Number(e.target.value))}
//             min="0"
//           />
//         </label>
//         <label style={{ marginLeft: "1rem" }}>
//           Rows:{" "}
//           <input
//             type="number"
//             value={rowCount}
//             onChange={(e) => setRowCount(Number(e.target.value))}
//             min="0"
//           />
//         </label>
//       </div>

//       {/* Only render diagram if > 0 */}
//       {colCount > 0 && rowCount > 0 && (
//         <div
//           className="diagram"
//           style={{
//             "--cols": columns.length,
//             "--rows": rows.length,
//             marginTop: "150px",
//           }}
//         >
//           {/* Axis labels */}
//           <div className="top-axis">Width of the building</div>
//           <div className="right-axis">Length of the building</div>

//           {/* Top measures */}
//           <div className="top-measures">
//             {measures.map((m, i) => (
//               <input
//                 className="m-input"
//                 key={`top-${i}`}
//                 defaultValue={m}
//                 type="text"
//               />
//             ))}
//           </div>

//           {/* Left measures */}
//           <div className="left-measures">
//             {sideMeasures.map((m, i) => (
//               <input
//                 className="m-input rotate"
//                 key={`left-${i}`}
//                 defaultValue={m}
//                 type="text"
//               />
//             ))}
//           </div>

//           {/* Right measures */}
//           <div className="right-measures">
//             {sideMeasures.map((m, i) => (
//               <input
//                 className="m-input rotate"
//                 key={`right-${i}`}
//                 defaultValue={m}
//                 type="text"
//               />
//             ))}
//           </div>

//           {/* Row labels */}
//           <div className="row-labels">
//             {rows.map((r, i) => (
//               <div className="row-label-wrapper" key={`row-${i}`}>
//                 <div className="r">{r}</div>
//                 <div className="row-connector"></div>
//               </div>
//             ))}
//           </div>

//           {/* Grid frame */}
//           <div className="frame">
//             {Array.from({ length: rows.length * columns.length }).map(
//               (_, i) => (
//                 <div className="cell" key={i}></div>
//               )
//             )}
//           </div>

//           {/* Column labels */}
//           <div className="bottom-labels">
//             {columns.map((c, i) => (
//               <div className="col-label-wrapper" key={`col-${i}`}>
//                 <div className="connector"></div>
//                 <div className="col-label">{c}</div>
//               </div>
//             ))}
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

export default EstimateList;
